import { DetailPageLayout } from "layouts/DetailPageLayout";
import { type ReactNode } from "react";
import { type RouteComponentProps } from "react-router-dom";

import { AppProvider } from "helpers/AppProvider";
import { AppProviderHandler, type IAppProviderHandler } from "helpers/AppProvider.api.handler";
import { BTAdminUserInfoProvider } from "helpers/globalContext/btAdmin/BTAdminUserInfoProvider";
import { BTLinkSpaRoutingProvider } from "helpers/globalContext/BTLinkSpaRoutingProvider";
import { DefaultEnabledSpaInfo, SpaInfoContext } from "helpers/globalContext/SPAInfoContext";

import { BTLayout } from "commonComponents/btWrappers/BTLayout/BTLayout";
import { BTAdminNavigation } from "commonComponents/utilities/BTAdminNavigation/BTAdminNavigation";

interface IBTAdminLayoutProps {
    /**
     * @deprecated use the `element` prop instead
     */
    component?: React.ComponentType<RouteComponentProps<any>>;
    element?: ReactNode;
    path: string;
    appProviderHandler?: IAppProviderHandler;
}

const defaultAppProviderHandler = new AppProviderHandler();
export const BTAdminLayout: React.FC<IBTAdminLayoutProps> = ({
    component,
    element,
    path,
    appProviderHandler = defaultAppProviderHandler,
}) => {
    return (
        <AppProvider handler={appProviderHandler}>
            <SpaInfoContext.Provider value={DefaultEnabledSpaInfo}>
                <BTLinkSpaRoutingProvider>
                    <BTLayout>
                        <BTAdminUserInfoProvider>
                            <div>
                                <BTAdminNavigation />
                                <DetailPageLayout
                                    component={component}
                                    element={element}
                                    path={path}
                                />
                            </div>
                        </BTAdminUserInfoProvider>
                    </BTLayout>
                </BTLinkSpaRoutingProvider>
            </SpaInfoContext.Provider>
        </AppProvider>
    );
};
export default BTAdminLayout;
